"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<a568b67172863c7af793decdb915a10f>>
 *
 * Generated by CLDRGenScript
 *
 * 
 */
var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType04 = {
  getVariation: function getVariation(n) {
    if (n >= 0 && n <= 1) {
      return IntlVariations.NUMBER_ONE;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType04;